import { useState, useEffect } from "react";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header
      id="header"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-sm shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-stone-900 flex items-center justify-center">
            <span className="text-white text-xs font-bold tracking-tight">D</span>
          </div>
          <span
            className={`font-semibold text-base tracking-wide transition-colors duration-300 ${
              scrolled ? "text-stone-900" : "text-white"
            }`}
          >
            DSS DOO
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {["about", "products", "contact"].map((item) => (
            <button
              key={item}
              onClick={() => scrollTo(item)}
              className={`text-sm font-medium uppercase tracking-widest transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled ? "text-stone-600 hover:text-stone-900" : "text-white/80 hover:text-white"
              }`}
            >
              {item}
            </button>
          ))}
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 transition-colors duration-300 ${scrolled ? "bg-stone-900" : "bg-white"}`} />
          <span className={`block w-6 h-0.5 transition-colors duration-300 ${scrolled ? "bg-stone-900" : "bg-white"}`} />
          <span className={`block w-4 h-0.5 transition-colors duration-300 ${scrolled ? "bg-stone-900" : "bg-white"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 flex flex-col gap-4">
          {["about", "products", "contact"].map((item) => (
            <button
              key={item}
              onClick={() => scrollTo(item)}
              className="text-sm font-medium uppercase tracking-widest text-stone-600 hover:text-stone-900 text-left cursor-pointer whitespace-nowrap"
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
